import {
  restore,
  setSeatsIO as sSIO,
  setExpiresAt as sEA,
  setExpiresInSeconds as sES,
} from './seats-io.slice';
import { useDispatch, useSelector } from 'react-redux';
import {
  useCreateHoldTokenMutation,
  useChangeExpirationHoldTokenMutation,
} from './seats-io.api';

export default function useSeatsIO() {
  const dispatch = useDispatch();
  const seatsIO = useSelector((state) => state.seatsIO);
  const [createHoldToken] = useCreateHoldTokenMutation();
  const [changeExpirationHoldToken] = useChangeExpirationHoldTokenMutation();

  const changeExpirationHoldTokenAndSave = async (holdToken, minutes = 15) => {
    if (holdToken) {
      const { data } = await changeExpirationHoldToken({
        expiresInMinutes: minutes,
        holdToken,
      });
      if (data) {
        setExpiresAt(data.expiresAt);
        setExpiresInSeconds(data.expiresInSeconds);
      }

      return data;
    }
  };

  const createHoldTokenAndSave = async (minutes = 15) => {
    const { data } = await createHoldToken(minutes);
    setSeatsIO(data);
    return data;
  };

  const setSeatsIO = (data) => {
    dispatch(sSIO(data));
  };

  const setExpiresAt = (expiresAt) => {
    dispatch(sEA(expiresAt));
  };

  const setExpiresInSeconds = (expiresInSeconds) => {
    dispatch(sES(expiresInSeconds));
  };

  const reset = () => {
    dispatch(restore());
  };

  return {
    changeExpirationHoldTokenAndSave,
    createHoldTokenAndSave,
    reset,
    seatsIO,
  };
}
